import React, { useState, useRef, useEffect } from 'react';
import './FaultSecondPageCustom_bus.css';
import * as $ from 'jquery';
import moment from 'moment';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { BsFillSkipBackwardBtnFill } from "react-icons/bs";
import { Link } from 'react-router-dom';

import { INIT_STATE_SELECTS } from '../../../../constants/driveglobalfilterinitalstates_bus';

export default function FaultSecondPageFilters_Bus(props) {
  const [filterdata, setFilterData] = useState({ ...props.secondPageState });
  const [singlevinerr, setSingleVinErro] = useState(false);
  const inputElement = useRef();
  const socref = useRef();
  let refdate
  const filterHideShow = () => {
    $("#filterSearch").toggle("slow");
  }

  const vinnumChanged = (e) => {
    let enterter_vin = e.target.value;
    setSingleVinErro(false);
    if (enterter_vin != "") {
      if (enterter_vin.indexOf(",") == -1) {
        setFilterData((prestate) => { return { ...filterdata, vin_num: enterter_vin } })
      } else {
        setSingleVinErro(true);
      }
    } else {
      setSingleVinErro(true);
    }
  }
  const startDateChanged = (date) => {
    setFilterData((prestate) => { return { ...filterdata, startDate: date } });
  }
  const endDateChanged = (date) => {
    setFilterData((prestate) => { return { ...filterdata, endDate: date } });
  }

  const [toSendChasisRCA, setToSendChasisRCA] = useState(0)
  const onsubmit = (e) => {
    e.preventDefault();
    if (inputElement.current.value == "") {
      setSingleVinErro(true);
    } else {
      setToSendChasisRCA(filterdata.vin_num)
      props.onsubmit(filterdata);
    }
  }

  const onreset = (e) => {
    e.preventDefault();
    setFilterData(INIT_STATE_SELECTS);
    inputElement.current.value = ""
    props.onreset(INIT_STATE_SELECTS);
  }

  const FirstPageCilcked = () => {
    props.pageChange();
  }
  const changeSoc = (e) => {
    setFilterData((prestate) => { return { ...filterdata, soc_per: parseInt(e.target.value) } });
  }

  useEffect(() => {
    setToSendChasisRCA(props.secondPageState.vin_num)
  }, [])
  return (
    <>

      <div className="container-fluid mt-3 cardBox busdrpg1">
        <div className="card card_bus busflt">
          <div className="card-body">
            <div className="row d-flex justify-content-between">
              {/* <div className="col-lg-5 col-sm-5 d-flex align-items-center"> */}
              <div className="col-lg-3 col-sm-3 d-flex align-items-center">
                <p className="small mb-0">Last Refresh Date:{refdate}</p>
              </div>
              {/* <div className="col-lg-5 col-sm-5 d-flex align-items-center"> */}
              <div className="col-lg-7 col-sm-7 d-flex align-items-center justify-content-center">
                <h5 className="mb-0 font-bus-head">Fault Analysis</h5>
              </div>
              {/* <div className="col-lg-2 col-sm-2 filter_bus_icon_f">
                <div className="text-end">
                  <button
                    type="button"
                    id="filterIcon"
                    className="btn btn-sm btn-outline-primary material-icons filter_bus_icon"
                    onClick={filterHideShow}
                  >
                    filter_alt
                  </button>
                </div>
              </div> */}

              <div className="col-lg-2 col-sm-2 text-end filter_bus_icon_f">
                <div className="rca_btn">
                  <Link to={`/dashboard_bus/rca_bus/${toSendChasisRCA}`}>
                    <button type="button" className="btn text-white rca_btn_bus mr-1"><i class="fa fa-cogs"></i><b>&nbsp;&nbsp;RCA</b></button>
                  </Link>
                  {/* </div>
                <div className="text-end d-inline-block"> */}
                  <button type="button" id="filterIcon" onClick={filterHideShow} className="btn btn-sm btn-outline-primary material-icons filter_bus_icon">filter_alt</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container-fluid mainDiv_bus busdrpg1">
        <div
          className="bg-light FilterDiv_bus p-2 mb-3"
          id="filterSearch"
          style={{ display: "none", zIndex: 1 }}
        >
          <form className="filterForm">
            <div className="row">
              <div className="col-lg-8">
                <div className="row">
                  <div className="col-lg-3 col-md-6 col-sm-12">
                    <div className="mb-3">
                      <label
                        htmlFor="exampleFormControlInput1"
                        className="form-label_bus"
                      >
                        Start Date
                      </label>
                      <DatePicker dateFormat="dd-MM-yyyy" minDate={moment(new Date("2023-08-15T00:00:00.000Z")).toDate()} maxDate={moment().subtract(1, "days").toDate()} selected={filterdata.startDate} onChange={startDateChanged} />
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-6 col-sm-12">
                    <div className="mb-3">
                      <label
                        htmlFor="exampleFormControlInput2"
                        className="form-label_bus"
                      >
                        End Date
                      </label>
                      <DatePicker dateFormat="dd-MM-yyyy" minDate={moment(new Date("2023-08-15T00:00:00.000Z")).toDate()} maxDate={moment().subtract(1, "days").toDate()} selected={filterdata.endDate} onChange={endDateChanged} />

                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6 col-sm-12">
                    <div className="mb-3">
                      <label
                        htmlFor="exampleFormControlInput2"
                        className="form-label_bus"
                      >
                        Chassis No / Reg No
                      </label>
                      <input autoComplete="off" defaultValue={filterdata.vin_num} className="top-filter filter-col" placeholder="Chassis No / Reg No" id="vin_num" ref={inputElement} onBlur={vinnumChanged} />
                      {singlevinerr && <spna style={{ fontSize: "11px", color: "red", fontWeight: 800 }}>* Please enter single Vin Number</spna>}

                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-4">
                <div className="row">
                  <div className="col-lg-4 col-md-4 col-sm-12 bus_filtr_btn filter_bus_icon_f">
                    <div className="mt-2">
                      <label htmlFor="" className="form-label_bus" />
                      <button type="submit" className="form-control btn btn_bus btn-primary" onClick={onsubmit}>
                        Search
                      </button>
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-4 col-sm-12 bus_filtr_btn filter_bus_icon_f">
                    <div className="mt-2">
                      <label htmlFor="" className="form-label_bus" />
                      <button
                        type="submit"
                        className="form-control btn btn-secondary"
                        onClick={FirstPageCilcked}><BsFillSkipBackwardBtnFill />

                      </button>
                    </div>
                  </div>

                  {/* <div className="col-lg-4 col-md-4 col-sm-12 bus_filtr_btn">
                    <div className="mt-2">
                      <label htmlFor="" className="form-label_bus" />
                      <Link to={`/dashboard_bus/rca_bus/${toSendChasisRCA}`}>
                        <button className="form-control btn text-white rca_btn_bus" ><i class="fa fa-cogs"></i>&nbsp;&nbsp;RCA</button>
                      </Link>
                    </div>
                  </div> */}
                </div>
              </div>
            </div>
          </form>
          {/* Filter Form Ends */}
        </div>
      </div >

    </>
  )
}
